import { useContext, useMemo } from 'react';
import { FluidImageContext } from '.';

const useFluidImage = (id?: string) => {
  const images = useContext(FluidImageContext);

  const gatsbyImageData = useMemo(() => {
    const img = images?.find((image) => image.id === id);
    return img?.localFile?.childImageSharp?.gatsbyImageData;
  }, [images, id]);

  return gatsbyImageData;
};

export default useFluidImage;
